<template>
  <div v-if="isVisible" class="complete-your-report-teaser">
    <div class="complete-your-report-teaser__button-label">
      {{ buttonLabel }}
    </div>

    <FieldWrapper class="field-wrapper--button field-wrapper--has-table">
      <Button
        :to="localePath({ name: ROUTE_NAMES.reports.year, params: { year: currentTaxYear } })"
        :size="BUTTON_STYLES.size.small"
      >
        {{ buttonText }}
      </Button>
    </FieldWrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { REPORT_STATUSES } from '@/store/report/report-settings'
import { ROUTE_NAMES } from '@/constants/route-names'
import { getCurrentTaxYear } from '@/helpers/time'
import FieldWrapper from '@/components/Form/FieldWrapper.vue'
import Button, { BUTTON_STYLES } from '@/components/Form/Button.vue'

export default {
  name: 'CompleteYourReportTeaser',
  components: {
    FieldWrapper,
    Button,
  },

  data() {
    return {
      BUTTON_STYLES,
      currentTaxYear: getCurrentTaxYear(),
      ROUTE_NAMES,
    }
  },

  computed: {
    ...mapGetters({
      getReportStatus: 'report/getReportStatus',
    }),

    isVisible() {
      return [
        REPORT_STATUSES.notStarted,
        REPORT_STATUSES.inProgress,
        // REPORT_STATUSES.paymentReceived,
      ].includes(this.reportStatus)
    },

    reportStatus() {
      return this.getReportStatus(this.currentTaxYear)
    },

    buttonLabel() {
      const keyMap = {
        [REPORT_STATUSES.notStarted]: 'noReportProducedThisYear',
        [REPORT_STATUSES.inProgress]: 'reportInProgress',
        // [REPORT_STATUSES.paymentReceived]: 'reportBeingProcessed',
      }
      const localeKey = keyMap[this.reportStatus] || keyMap[REPORT_STATUSES.notStarted]
      return this.$t(`account.${localeKey}`, { year: this.currentTaxYear })
    },

    buttonText() {
      const keyMap = {
        [REPORT_STATUSES.notStarted]: 'startReport',
        [REPORT_STATUSES.inProgress]: 'continueReport',
        // [REPORT_STATUSES.paymentReceived]: 'seeReport',
      }
      const localeKey = keyMap[this.reportStatus] || keyMap[REPORT_STATUSES.notStarted]
      return this.$t(`account.${localeKey}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.complete-your-report-teaser {
  margin-bottom: $white-block-gutter;

  @include min-screen($mq-medium) {
    margin-bottom: $white-block-gutter-medium;
  }

  &__button-label {
    margin: 0 $table-padding-x $label-margin-bottom;
  }
}
</style>
